/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B3_DInputs */

const en_mk_abt_b3_d = /** @type {(inputs: Mk_Abt_B3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI cost is not something to hide behind the word “credits”. We show it in rupiah, per run, from day one.`)
};

const id_mk_abt_b3_d = /** @type {(inputs: Mk_Abt_B3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya AI bukan hal yang pantas disembunyikan di balik kata "kredit". Kami menampilkannya dalam rupiah, per run, sejak hari pertama.`)
};

/**
* | output |
* | --- |
* | "AI cost is not something to hide behind the word “credits”. We show it in rupiah, per run, from day one." |
*
* @param {Mk_Abt_B3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b3_d = /** @type {((inputs?: Mk_Abt_B3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b3_d(inputs)
	return en_mk_abt_b3_d(inputs)
});